import React from 'react';
import { Router, Route, IndexRoute, IndexRedirect, Redirect, browserHistory } from 'react-router';
import * as containers from './containers';
import { ComponentsLayout, HomePageLayout, PageWrapperLayout } from './layouts';

const history = browserHistory;

history.listen((location) => {
	// Use setTimeout to make sure this runs after React Router's own listener
	setTimeout(() => {
		window.ga('set', 'page', location.pathname + location.search);
		window.ga('send', 'pageview', location.pathname + location.search);
		// Keep default behavior of restoring scroll position when user:
		// - clicked back button
		// - clicked on a link that programmatically calls `history.goBack()`
		// - manually changed the URL in the address bar (here we might want
		// to scroll to top, but we can't differentiate it from the others)
		if (location.action === 'POP') {
			return;
		}
		// In all other cases, check fragment/scroll to top
		const hash = window.location.hash;
		if (hash) {
			const element = document.querySelector(hash);
			if (element) {
				element.scrollIntoView({ block: 'start', behavior: 'smooth' });
			}
		} else {
			window.scrollTo(0, 0);
		}
	});
});

// All information on each component page is based on the pathname below. This site searches for the matching pathname in the components section of design system react's package.json. Therefore pathnames should align.

// Route order matters.

const Routes = (
	<Router history={browserHistory}>
		<Route path="/" component={PageWrapperLayout}>

			<Route component={HomePageLayout}>
				<IndexRoute component={containers.HomePageView} />
			</Route>

			<Route path="components" component={ComponentsLayout}>
				<IndexRedirect to="accordions" />
			</Route>

			<Route path="components/:component" component={ComponentsLayout} >
				<IndexRoute component={containers.ComponentRenderer} />

				<Redirect from="app-launcher" to="app-launcher/" />
				<Redirect from="breadcrumbs" to="breadcrumbs/" />
				<Redirect from="buttons" to="buttons/" />
				<Redirect from="stateful-buttons" to="stateful-buttons/" />
				<Redirect from="cards" to="cards/" />
				<Redirect from="checkboxes" to="checkboxes/" />
				<Redirect from="global-header" to="global-header/" />
				<Redirect from="global-navigation-bar" to="global-navigation-bar/" />
				<Redirect from="data-tables" to="data-tables/" />
				<Redirect from="datepickers" to="datepickers/" />
				<Redirect from="icons" to="icons/" />
				<Redirect from="inline-edit-inputs" to="inline-edit-inputs/" />
				<Redirect from="inputs" to="inputs/" />
				<Redirect from="lookups" to="lookups/" />
				<Redirect from="dropdown-menus" to="dropdown-menus/" />
				<Redirect from="media-objects" to="media-objects/" />
				<Redirect from="picklist-menus" to="picklist-menus/" />
				<Redirect from="modals" to="modals/" />
				<Redirect from="notifications" to="notifications/" />
				<Redirect from="page-headers" to="page-headers/" />
				<Redirect from="popover-tooltips" to="popover-tooltips" />
				<Redirect from="tabs" to="tabs/" />
				<Redirect from="timepickers" to="timepickers/" />
				<Redirect from="tree" to="tree/" />
			</Route>

			<Route path=":section/" component={ComponentsLayout}>
				<IndexRoute component={containers.Content} />
			</Route>

		</Route>
	</Router>
);

export default Routes;



// WEBPACK FOOTER //
// ./public/src/routes.js